export const CHANNEL_SOCKET = {
  SERVING_TOKENS: 'Clients::ServingTokensChannel',
  SERVING_SESSION: 'Clients::SessionsChannel',
}

export const EVENT_CODE = {
  A_BUFFET_WAS_CANCELLED: 'A_BUFFET_WAS_CANCELLED',
  BUFFET_REQUEST_STARTED: 'BUFFET_REQUEST_STARTED',
}
